import { Observable } from "rxjs";

type OS = "windows" | "macOS" | "unix" | "linux";

// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/appVersion
export const getBrowserOS = (): OS => {
  if (navigator.appVersion.indexOf("Win") != -1) {
    return "windows";
  }

  if (navigator.appVersion.indexOf("Mac") != -1) {
    return "macOS";
  }

  if (navigator.appVersion.indexOf("X11") != -1) {
    return "unix";
  }

  if (navigator.appVersion.indexOf("Linux") != -1) {
    return "linux";
  }
};
export class ResizeObservable extends Observable<ResizeObserverEntry[]> {
  constructor(elem: HTMLElement) {
    super((subscriber) => {
      let prevWidth = 0;

      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const width = entry.borderBoxSize?.[0].inlineSize;
          if (typeof width === "number" && width !== prevWidth) {
            prevWidth = width;
            subscriber.next(entries);
          }
        }
      });

      resizeObserver.observe(elem);

      return function unsubscribe(): void {
        resizeObserver.unobserve(elem);
        resizeObserver.disconnect();
      };
    });
  }
}
